import Vue from "vue"
// 获取表格选中行ID
const getSelectId = (val) => {
  let arr = []
  if (val.length == 0) {
    Vue.prototype.$message({
      showClose: true,
      message: "请先选择数据",
      duration: 1000,
      type: "warning",
    })
    return false
  }
  for (let i = 0; i < val.length; i++) {
    if (arr.indexOf(val[i].id) === -1) {
      arr.push(val[i].id)
    }
  }
  return arr
}
//重置表单内容及校验提示信息
const resetForm = (_this, formName) => {
  if (_this.$refs[formName]) {
    _this.$refs[formName].resetFields()
  }
}
//详情内容校验
const judgeEmpty = (val) => {
  if (val == "" || val == null) {
    return "-"
  } else {
    return val
  }
}

//详情内容校验[返回0]
const judgeEmptyZ = (val) => {
  if (val == "" || val == null) {
    return 0
  } else {
    return val
  }
}

//判空并保留两位小数
const toFixed2 = (val) => {
  if (val == "" || val == null) {
    return "-"
  } else {
    return val.toFixed(2)
  }
}

// 线上环境禁止打印console.log
const rewriteLog = () => {
  console.log = (function (log) {
    return process.env.NODE_ENV == 'production' ? function () { } : log
  }(console.log))
}

//获取当前时间
const nowDate = () => {
  let date = new Date()
  let nowDate = ""
  let year = date.getFullYear() // 年
  let month = date.getMonth() + 1 // 月
  month = month < 10 ? "0" + month : month
  let day = date.getDate() // 日
  day = day < 10 ? "0" + day : day
  let hour = date.getHours() // 时
  hour = hour < 10 ? "0" + hour : hour
  let minute = date.getMinutes() // 分
  minute = minute < 10 ? "0" + minute : minute
  let second = date.getSeconds() // 秒
  second = second < 10 ? "0" + second : second
  nowDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`
  return nowDate
}

const myThrottle = (func, delay) => {
  // 缓存一个定时器
  let timer = null
  // 这里返回的函数是每次用户实际调用的节流函数 
  return function (...args) {
    if (!timer) { //判断timer是否有值,如果没有则说明定时器不存在即可继续执行
      timer = setTimeout(() => { //关
        func.apply(this, args)
        timer = null; //开
      }, delay)
    }
  }
}
export { getSelectId, resetForm, judgeEmpty, judgeEmptyZ, nowDate, toFixed2, myThrottle, rewriteLog }
